import { Button as MUIButton, ButtonProps as MUIButtonProps } from '@mui/material';
import classNames from 'classnames';
import { forwardRef } from 'react';

import classes from './Button.module.scss';

const Button = forwardRef<HTMLButtonElement, MUIButtonProps>(
  ({ variant = 'contained', size = 'medium', type = 'button', ...props }, ref) => {
    return (
      <MUIButton
        {...props}
        type={type}
        className={classNames(classes.Button, props.className)}
        variant={variant}
        ref={ref}
        disableElevation
        size={size}
        classes={{
          ...props.classes,
          sizeLarge: classes.Large,
          sizeMedium: classes.Medium,
          sizeSmall: classes.Small,
          endIcon: classes.EndIcon,
          startIcon: classes.StartIcon,
          outlined: classes.Outlined,
        }}
      />
    );
  }
);
Button.displayName = 'Button';

export default Button;
